import * as React from "react";
const majorVersion = parseInt(React.version, 10);
function isReactVersionAtLeast(reactVersionToCheck) {
  return majorVersion >= reactVersionToCheck;
}
export {
  isReactVersionAtLeast
};
//# sourceMappingURL=reactVersion.js.map
